import { AdPlacement } from "@/components/ads/AdPlacement";
import {
  SciBreadcrumb,
  SciExplainer,
  SciHeader,
  SciPage,
} from "@/lib/science/sci-ui";
import { m } from "@/paraglide/messages";
import { GcSkewCalc } from "../components/GcSkewCalc";

export function CalculatorPage() {
  return (
    <SciPage>
      <SciBreadcrumb
        homeLabel={m.sci_breadcrumb_home()}
        toolName={m.gcskew_tool_name()}
        toolPath="/gc-skew"
      />
      <SciHeader title={m.gcskew_h1()} intro={m.gcskew_intro()} />

      <GcSkewCalc />

      <SciExplainer
        howToTitle={m.sci_howto_title()}
        howTo={m.gcskew_howto()}
        examplesTitle={m.sci_examples_title()}
        examples={[m.gcskew_ex1(), m.gcskew_ex2(), m.gcskew_ex3()]}
        faqTitle={m.sci_faq_title()}
        faqs={[
          { q: m.gcskew_faq_q1(), a: m.gcskew_faq_a1() },
          { q: m.gcskew_faq_q2(), a: m.gcskew_faq_a2() },
          { q: m.gcskew_faq_q3(), a: m.gcskew_faq_a3() },
          { q: m.gcskew_faq_q4(), a: m.gcskew_faq_a4() },
        ]}
      />

      <AdPlacement className="mt-10" />
    </SciPage>
  );
}
